import { Box } from '@mantine/core';
import { ConfigFieldValue } from '@/types/automationFields.ts';
import { ReactNode } from 'react';
import useFieldConfigError from '@/hooks/useFieldConfigError.ts';
import StyledNumberInput from '@/components/StyledInputFields/StyledNumberInput.tsx';
import { IntegrationNumberConfigField } from '@/types/integrations.ts';
import { getStringRightSectionProps } from '@/pages/Editor/components/SharedFields/IntegrationFields/IntegrationFieldTypes/getStringRightSectionProps.tsx';

type props = {
  stepId: string;
  field: IntegrationNumberConfigField;
  fieldValue: any;
  fieldValueConfig: ConfigFieldValue;
  onChange: (updated_value: any) => void;
  rightSection?: ReactNode;
};

const NumberInputField = ({
  stepId,
  field,
  fieldValue,
  fieldValueConfig,
  onChange,
  rightSection,
}: props) => {
  const error = useFieldConfigError(stepId, fieldValueConfig);
  const rightSectionProps = getStringRightSectionProps(field.right_section_text || rightSection);

  return (
    <Box pos="relative">
      <StyledNumberInput
        label={field.display_name}
        value={fieldValue ?? ''}
        description={field.description ?? undefined}
        placeholder={field.placeholder ?? undefined}
        onChange={(newValue) => onChange(newValue.toString())}
        required={field.required}
        maxLength={field.max_length ?? undefined}
        error={error?.message}
        {...rightSectionProps}
        disabled={fieldValueConfig.is_disabled}
        readOnly={field.read_only}
      />
    </Box>
  );
};

export default NumberInputField;
